var Utils = require("./utils");
var queryArray = Utils.queryArray;

var bgCategorySelector = document.getElementById("buyersGuideCategories");
var membershipCategorySelector = document.getElementById(
  "membershipCategories"
);
var countrySelect = document.getElementById("country");
var stateSelect = document.getElementById("state");

var countries = [
  { value: "", text: "All Countries" },
  { value: "US", text: "United States" },
  { value: "BR", text: "Brazil" },
  { value: "CA", text: "Canada" },
  { value: "CL", text: "Chile" },
  { value: "CN", text: "China" },
  { value: "EG", text: "Egypt" },
  { value: "IN", text: "India" },
  { value: "IR", text: "Iran (Islamic Republic Of)" },
  { value: "IL", text: "Israel" },
  { value: "KR", text: "Korea, Republic Of" },
  { value: "MX", text: "Mexico" },
  { value: "PK", text: "Pakistan" },
  { value: "PH", text: "Philippines" },
  { value: "PL", text: "Poland" },
  { value: "TW", text: "Taiwan" },
  { value: "AE", text: "United Arab Emirates" },
];

var usStates = [
  { text: "Alabama", value: "AL" },
  { text: "Alaska", value: "AK" },
  { text: "Arizona", value: "AZ" },
  { text: "Arkansas", value: "AR" },
  { text: "California", value: "CA" },
  { text: "Colorado", value: "CO" },
  { text: "Connecticut", value: "CT" },
  { text: "Delaware", value: "DE" },
  { text: "District of Columbia", value: "DC" },
  { text: "Florida", value: "FL" },
  { text: "Georgia", value: "GA" },
  { text: "Hawaii", value: "HI" },
  { text: "Idaho", value: "ID" },
  { text: "Illinois", value: "IL" },
  { text: "Indiana", value: "IN" },
  { text: "Iowa", value: "IO" },
  { text: "Kansas", value: "KS" },
  { text: "Kentucky", value: "KY" },
  { text: "Louisiana", value: "LA" },
  { text: "Maine", value: "ME" },
  { text: "Maryland", value: "MD" },
  { text: "Massachusetts", value: "MA" },
  { text: "Michigan", value: "MI" },
  { text: "Minnesota", value: "MN" },
  { text: "Mississippi", value: "MS" },
  { text: "Missouri", value: "MO" },
  { text: "Montana", value: "MT" },
  { text: "Nebraska", value: "NE" },
  { text: "Nevada", value: "NV" },
  { text: "New Hampshire", value: "NH" },
  { text: "New Jersey", value: "NJ" },
  { text: "New Mexico", value: "NM" },
  { text: "New York", value: "NY" },
  { text: "North Carolina", value: "NC" },
  { text: "North Dakota", value: "ND" },
  { text: "Ohio", value: "OH" },
  { text: "Oklahoma", value: "OK" },
  { text: "Oregon", value: "OR" },
  { text: "Pennsylvania", value: "PA" },
  { text: "Rhode Island", value: "RI" },
  { text: "South Carolina", value: "SC" },
  { text: "South Dakota", value: "SD" },
  { text: "Tennessee", value: "TN" },
  { text: "Texas", value: "TX" },
  { text: "Utah", value: "UT" },
  { text: "Vermont", value: "VT" },
  { text: "Virginia", value: "VA" },
  { text: "Washington", value: "WA" },
  { text: "West Virginia", value: "WV" },
  { text: "Wisconsin", value: "WI" },
  { text: "Wyoming", value: "WY" },
];

var membershipCategoriesOpts = [
  { value: "Associate", text: "Associate" },
  { value: "Converter", text: "Converter" },
  {
    value: "International",
    text: "International Converter",
  },
  { 
    value: "Supporting - Banking", 
    text: "Supporting (Banking Sector)" 
  },{ 
    value: "Supporting", 
    text: "Supporting (Other Sectors)" 
  },
];

if (!membershipCategorySelector.classList.contains("buyers-guide")) {
  membershipCategoriesOpts.push({ value: "Academic", text: "Academic" });
  membershipCategoriesOpts.push({ value: "Trade Press", text: "Trade Press" });
}

$(function () {
  $(bgCategorySelector).selectize({
    options: buyersGuideCategoriesOpts.options,
    optgroups: buyersGuideCategoriesOpts.optgroups,
    maxItems: null,
    placeholder: "Select categories to narrow your search.",
    items: bgCategories,
  });
  $(membershipCategorySelector).selectize({
    options: membershipCategoriesOpts,
    maxItems: null,
    placeholder: "Select categories to narrow your search.",
    items:
      membershipCategories ||
      membershipCategoriesOpts.map(function (cat) {
        return cat.value;
      }),
  });
  var stateSelectize = $(stateSelect).selectize({
    options: usStates,
    maxItems: 1,
    placeholder: "All states.",
    items: lookupState,
  });
  var stateSelector = document.querySelector(".selectize-control.state");
  var countrySelectize = $(countrySelect).selectize({
    onChange: function (value) {
      if (value == "US") {
        stateSelector.classList.remove("hidden");
      } else {
        stateSelector.classList.add("hidden");
        stateSelectize[0].selectize.clear(true);
      }
    },
    onLoad: function () {
      console.log("lookup country: " + lookupCountry);
      if (lookupCountry && lookupCountry == "US") {
        console.log("here");
        stateSelector.classList.remove("hidden");
      } else {
        console.log("there");
        stateSelector.classList.add("hidden");
        stateSelectize[0].selectize.clear(true);
      }
    },
    options: countries,
    maxItems: 1,
    placeholder: "All countries.",
    items: lookupCountry,
  });
  if (bgCategories.length) {
    bgCategorySelector.selectize.setValue(bgCategories, true);
  }
  if (membershipCategories.length) {
    membershipCategorySelector.selectize.setValue(membershipCategories, true);
  }
});

var searchForm = document.getElementById("directory-search");

searchForm.addEventListener("submit", function (e) {
  e.preventDefault();

  var memberCategoryIds = Array.prototype.slice
    .call(membershipCategorySelector.selectedOptions)
    .map(function (option) {
      return option.value;
    });
  var keywords = document.getElementById("keyword").value || "";
  var country = document.getElementById("country").value || "";
  var state = document.getElementById("state").value || "";
  var categoryIds = Array.prototype.slice
    .call(bgCategorySelector.selectedOptions)
    .map(function (option) {
      return option.value;
    });

  var membershipCategoryQuery =
    memberCategoryIds && memberCategoryIds.length
      ? "membershipCategory=" + memberCategoryIds.join(",")
      : "";
  var keywordsQuery = keywords != "" ? "keywords=" + keywords : "";
  var countryQuery = country != "" ? "country=" + country : "";
  var stateQuery = state != "" ? "state=" + state : "";
  var categoryIdsQuery =
    categoryIds && categoryIds.length
      ? "categories=" + categoryIds.join(",")
      : "";

  var returnQueries = membershipCategoryQuery
    ? "?" + membershipCategoryQuery
    : "";
  returnQueries += keywordsQuery
    ? (membershipCategoryQuery ? "&" : "?") + keywordsQuery
    : "";
  returnQueries += countryQuery
    ? (membershipCategoryQuery || keywordsQuery ? "&" : "?") + countryQuery
    : "";
  returnQueries += stateQuery
    ? (membershipCategoryQuery || keywordsQuery || countryQuery ? "&" : "?") +
      stateQuery
    : "";
  returnQueries += categoryIdsQuery
    ? (membershipCategoryQuery || keywordsQuery || countryQuery || stateQuery
        ? "&"
        : "?") + categoryIdsQuery
    : "";

  var returnUrl = window.location.pathname + returnQueries;

  window.location.href = returnUrl;
});
